import React, { useCallback, useState } from "react";
import { Select, Tooltip } from "antd";
import { EyeOutlined } from "@ant-design/icons";

import { FundamentacaoModal } from "../FundamentacaoModal";
import { openNotification } from "../Notification";

const { Option } = Select;

export function SelectLocalOcorrencia({
  localOcorrencia = [],
  disabled,
  fetchFundamentacao,
  placeholder = "selecionar...",
  ...selectProps
}) {
  const [modalVisible, setModalVisible] = useState(false);
  const [localSelect, setLocalSelect] = useState(null);
  const [fundamentacao, setFundamentacao] = useState("");
  const [loadingFundamentacao, setLoadingFundamentacao] = useState(false);
  const [dropdownVisible, setDropdownVisible] = useState(false);

  const handleOpenFundamentacao = useCallback(
    async (local, event) => {
      event?.preventDefault();
      event?.stopPropagation();
      setDropdownVisible(false);
      setLocalSelect(local);
      setModalVisible(true);
      setLoadingFundamentacao(true);

      if (local.fundamentacao) {
        setFundamentacao(local.fundamentacao);
        setLoadingFundamentacao(false);
        return;
      }

      if (!fetchFundamentacao) {
        setFundamentacao("");
        setLoadingFundamentacao(false);
        return;
      }

      try {
        const response = await fetchFundamentacao(local.codigo);
        setFundamentacao(response.data?.fundamentacao || "");
      } catch (reason) {
        openNotification(
          "error",
          <strong>
            Ocorreu um erro ao buscar a fundamentação do local de notificação/
            manifestação!
          </strong>,
          reason?.response?.data?.detail,
        );
        setFundamentacao("");
      } finally {
        setLoadingFundamentacao(false);
      }
    },
    [fetchFundamentacao],
  );

  return (
    <>
      <Select
        autoComplete="none"
        placeholder={placeholder}
        disabled={disabled}
        showSearch
        optionLabelProp="label"
        dropdownVisible={dropdownVisible}
        onDropdownVisibleChange={setDropdownVisible}
        filterOption={(input, option) =>
          option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
        }
        {...selectProps}
      >
        {localOcorrencia.map((local) => (
          <Option
            key={local.codigo}
            value={local.codigo}
            label={local.descricao}
          >
            <EyeOutlined
              style={{
                fontSize: "1rem",
                color: "#ff9945",
                marginRight: "0.5rem",
              }}
              onMouseDown={(event) => event.preventDefault()}
              onClick={(event) => handleOpenFundamentacao(local, event)}
            />
            <Tooltip placement="top" title={local.descricao}>
              {local.descricao}
            </Tooltip>
          </Option>
        ))}
      </Select>

      <FundamentacaoModal
        visible={modalVisible}
        onClose={() => setModalVisible(false)}
        title={`FUNDAMENTAÇÃO DO LOCAL DE NOTIFICAÇÃO/ MANIFESTAÇÃO: ${localSelect?.descricao}`}
        fundamentacao={fundamentacao}
        loading={loadingFundamentacao}
      />
    </>
  );
}
